export const pascalCase = (input = "") =>
  input
    .split(/[^a-zA-Z0-9]/)
    .map((s) => s.toLowerCase())
    .map((s) => (s[0] ?? "").toUpperCase() + s.substring(1))
    .join("");

export const camelCase = (input = "") => {
  const s = pascalCase(input);
  return (s[0] ?? "").toLowerCase() + s.substring(1);
};

export const kebabCase = (input = "") => {
  const s = pascalCase(input);
  return s.replace(/[A-Z]/g, (d) => "-" + d.toLowerCase()).substring(1);
};

export const snakeCase = (input = "") => {
  const s = pascalCase(input);
  return s.replace(/[A-Z]/g, (d) => "_" + d.toLowerCase()).substring(1);
};
